// extracted by mini-css-extract-plugin
export var article = "styles-module--article--B6-Ok";